module.exports = __webpack_public_path__ + "prod/1.42.2/img/font1.b4e3c8f9.png";